import arjunPortrait from '../assets/arjun.png';
import showyabPortrait from '../assets/showyab.jpeg';
import hrythumPortrait from '../assets/hrythum.jpeg';
import harshPortrait from '../assets/harsh.jpeg';
import tusharPortrait from '../assets/tushar.jpeg';
import gridPattern from '../assets/brand-grid.svg';
import { featuredProjects, heroStats } from '../assets/siteData';
import { Button } from '../components/Button';
import { Section } from '../components/Section';

const spotlightPortraits = [
  { src: arjunPortrait, alt: 'Arjun Sharma portrait', name: 'Arjun Sharma' },
  { src: showyabPortrait, alt: 'Shoyab portrait', name: 'Shoyab' },
  { src: hrythumPortrait, alt: 'Hrythum Raj Sharma portrait', name: 'Hrythum Raj Sharma' },
  { src: harshPortrait, alt: 'Harsh portrait', name: 'Harsh' },
  { src: tusharPortrait, alt: 'Tushar portrait', name: 'Tushar' }
];

export function HomePage() {
  const selectedPortrait = spotlightPortraits[Math.floor(Math.random() * spotlightPortraits.length)];

  return (
    <>
      <section className="hero shell">
        <div className="hero__panel glass-panel">
          <img className="hero__pattern" src={gridPattern} alt="" aria-hidden="true" />
          <div className="hero__content">
            <div className="hero__copy">
              <p className="eyebrow">Developer | Founder of VappyTech | Educator</p>
              <h1 className="hero__headline">
                I Build Digital Experiences, Startups & Future Tech
              </h1>
              <p className="hero__description">
                VappyTech is a MERN-driven team, startup brand, and education studio creating premium product experiences, trusted client work, and practical robotics learning ecosystems.
              </p>
              <div className="hero__actions">
                <Button to="/contact">Hire Me</Button>
                <Button to="/portfolio" variant="secondary">
                  View Work
                </Button>
              </div>
            </div>

            <div className="hero__spotlight">
              <div className="spotlight-card spotlight-card--portrait">
                <div className="spotlight-portrait">
                  <img src={selectedPortrait.src} alt={selectedPortrait.alt} />
                  <div className="spotlight-badge">
                    <strong>{selectedPortrait.name}</strong>
                    <span>Developer • Founder • Educator</span>
                  </div>
                </div>
                <div className="spotlight-copy">
                  <p className="eyebrow">Premium positioning</p>
                  <h2>Built like a product brand, not a basic portfolio.</h2>
                  <div className="spotlight-list">
                    <div>
                      <strong>VappyTech</strong>
                      <span>Startup vision, SaaS thinking, product polish</span>
                    </div>
                    <div>
                      <strong>Udann</strong>
                      <span>Project-based learning for programming and robotics</span>
                    </div>
                    <div>
                      <strong>Freelance</strong>
                      <span>Client websites and web apps with premium trust signals</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="stats-grid">
            {heroStats.map((item) => (
              <div className="stat-card" key={item.label}>
                <strong>{item.value}</strong>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Section
        className="feature-showcase"
        eyebrow="Featured Projects"
        title="Selected work shaped to feel like premium digital products"
        description="Each project card is positioned to communicate quality, strategic thinking, and execution confidence."
      >
        <div className="feature-grid feature-grid--showcase">
          {featuredProjects.map((project) => (
            <article
              className={`feature-card feature-card--showcase glass-panel feature-card--${project.accent}`}
              key={project.title}
            >
              <div className="feature-card__media">
                <img className="feature-card__image" src={project.image} alt={project.alt} loading="lazy" />
                <div className="feature-card__overlay">
                  <span>{project.category}</span>
                  <small>{project.eyebrow}</small>
                </div>
              </div>
              <div className="feature-card__body">
                <p className="eyebrow">{project.category}</p>
                <h3>{project.title}</h3>
                <p>{project.summary}</p>
                <div className="tag-row">
                  {project.stack.map((item) => (
                    <span className="tag" key={item}>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </Section>

      <Section className="section--split">
        <div className="glass-panel split-card">
          <p className="eyebrow">About Preview</p>
          <h2>Technical depth backed by founder energy and teaching clarity.</h2>
          <p>
            Arjun blends MERN stack delivery, strong UI/UX instincts, and a practical teaching mindset to create work that looks world-class and feels easy to trust.
          </p>
          <Button to="/about" variant="secondary">
            Read the Journey
          </Button>
        </div>
        <div className="glass-panel split-card split-card--quote">
          <p className="eyebrow">Daily Quote</p>
          <blockquote>“Design the experience so well that trust is built before the pitch even begins.”</blockquote>
          <span>Static quote placeholder</span>
        </div>
      </Section>

      <Section>
        <div className="cta-banner glass-panel">
          <div>
            <p className="eyebrow">High-Converting CTA</p>
            <h2>Need a product, website, or learning brand that feels premium from the first second?</h2>
            <p>
              Work with Arjun to launch high-end client experiences, scalable startup visuals, or practical tech education offerings.
            </p>
          </div>
          <div className="cta-banner__actions">
            <Button to="/contact">Hire Arjun</Button>
            <Button to="/businesses" variant="secondary">
              Explore Businesses
            </Button>
          </div>
        </div>
      </Section>
    </>
  );
}
